<template>
  <div class="registration-form">
    <b-overlay :show="loading">
      <div class="registration-inner" v-if="!doneRegistration">
        <div class="row">
          <div class="col">
            <p>
              If you are a customer who would like a website login, or if you’re
              interested in using Jeroboams Trade as your wine supplier please
              fill in the form below and we will be in touch.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <b-form-group
              :id="'registration-short-form-input-firstname-label-' + _uid"
              label="First Name"
              :label-for="
                'registration-short-form-input-firstname-input-' + _uid
              "
            >
              <b-form-input
                :id="'registration-short-form-input-firstname-input-' + _uid"
                name="firstname"
                v-model="$v.form.firstname.$model"
                :state="validateState('firstname')"
                :aria-describedby="
                  'registration-short-form-input-firstname-feedback-' + _uid
                "
              ></b-form-input>
              <b-form-invalid-feedback
                :id="'registration-short-form-input-firstname-feedback-' + _uid"
              >
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group
              :id="'registration-short-form-input-lastname-label-' + _uid"
              label="Last Name"
              :label-for="
                'registration-short-form-input-lastname-input-' + _uid
              "
            >
              <b-form-input
                :id="'registration-short-form-input-lastname-input-' + _uid"
                name="lastname"
                v-model="$v.form.lastname.$model"
                :state="validateState('lastname')"
                :aria-describedby="
                  'registration-short-form-input-lastname-feedback-' + _uid
                "
              ></b-form-input>
              <b-form-invalid-feedback
                :id="'registration-short-form-input-lastname-feedback-' + _uid"
              >
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
        <b-form-group
          id="registration-short-form-company"
          label="Company:"
          label-for="registration-short-form-company"
        >
          <b-form-input
            id="registration-short-form-company"
            v-model="$v.form.company.$model"
            :state="validateState('company')"
            type="text"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :id="'registration-short-form-input-company-feedback-' + _uid"
          >
            This is a required field.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="registration-short-form-email"
          label="Email address:"
          label-for="registration-short-form-email"
        >
          <b-form-input
            id="registration-short-form-email"
            v-model="$v.form.email.$model"
            :state="validateState('email')"
            type="email"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :id="'registration-short-form-input-email-feedback-' + _uid"
          >
            Please enter a valid email address
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="registration-short-form-telephone"
          label="Telephone:"
          label-for="registration-short-form-telephone"
        >
          <b-form-input
            id="registration-short-form-telephone"
            v-model="$v.form.telephone.$model"
            :state="validateState('telephone')"
            type="tel"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :id="'registration-short-form-input-telephone-feedback-' + _uid"
          >
            Please enter a valid email address
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group class="text-center">
          <b-form-radio
            inline
            v-model="registration_type"
            name="registration_type"
            value="register"
            >Existing Customer</b-form-radio
          >
          <b-form-radio
            inline
            v-model="registration_type"
            name="registration_type"
            value="enquire"
            >New Customer</b-form-radio
          >
        </b-form-group>
        <b-form-group
          v-if="registration_type === 'enquire'"
          label="Type of Business"
        >
          <b-form-select v-model="$v.form.businesstype.$model" class="">
            <b-form-select-option value=""
              >Please select an option</b-form-select-option
            >
            <b-form-select-option value="Restaurant"
              >Restaurant</b-form-select-option
            >
            <b-form-select-option value="Pub">Pub</b-form-select-option>
            <b-form-select-option value="Hotel">Hotel</b-form-select-option>
            <b-form-select-option value="Events Catering"
              >Events Catering</b-form-select-option
            >
            <b-form-select-option value="Corporate"
              >Corporate</b-form-select-option
            >
            <b-form-select-option value="Contract Catering"
              >Contract Catering</b-form-select-option
            >
            <b-form-select-option value="Wholesale/Retailer"
              >Wholesale/Retailer</b-form-select-option
            >
            <b-form-select-option value="Members Club"
              >Members Club</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
        <b-form-group
          v-if="registration_type === 'enquire'"
          label="Reason for enquiry"
        >
          <b-form-select v-model="$v.form.enquiryreason.$model" class="">
            <b-form-select-option value=""
              >Please select an option</b-form-select-option
            >
            <b-form-select-option value="We are looking for a new wine supplier"
              >We are looking for a new wine supplier</b-form-select-option
            >
            <b-form-select-option
              value="We are looking to expand/update our range of wines"
              >We are looking to expand/update our range of
              wines</b-form-select-option
            >

            <b-form-select-option value="General enquiry about your wines"
              >General enquiry about your wines</b-form-select-option
            >

            <b-form-select-option value="Request for a price list"
              >Request for a price list</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
        <b-form-group v-if="registration_type === 'enquire'" label="Comments">
          <b-form-textarea v-model="form.comments"></b-form-textarea>
        </b-form-group>
        <b-form-group
          v-if="registration_type === 'register'"
          :id="'registration-short-form-input-password-label-' + _uid"
          label="Create a password"
          :description="passwordStrengthMessage"
          :label-for="'registration-short-form-input-password-input-' + _uid"
        >
          <b-form-input
            :id="'registration-short-form-input-password-input-' + _uid"
            name="password1"
            type="password"
            placeholder="Your password"
            v-model="$v.form.password1.$model"
            :state="validateState('password1')"
            :aria-describedby="
              'registration-short-form-input-password-feedback-' + _uid
            "
          ></b-form-input>
          <b-form-input
            class="mt-1"
            :id="'registration-short-form-input-password2-input-' + _uid"
            name="password2"
            type="password"
            placeholder="Confirm your password"
            v-model="$v.form.password2.$model"
            :state="validateState('password2')"
            :aria-describedby="
              'registration-short-form-input-password2-feedback-' + _uid
            "
          ></b-form-input>
          <b-form-invalid-feedback
            :id="'registration-short-form-input-password2-feedback-' + _uid"
          >
            {{ passwordStrengthErrorMessage }}
          </b-form-invalid-feedback>
        </b-form-group>
        <div class="text-center mb-2">
          <b-button
            variant="success"
            :disabled="$v.$invalid"
            @click="doRegistration"
            >Register</b-button
          >
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
/* global wp gtag */

import { required, email } from "vuelidate/lib/validators";

const passwordStrength = function passwordStrength() {
  if (!this.form.password2) {
    return false;
  }

  if (this.passwordStrength >= 3 && this.passwordStrength < 5) {
    return true;
  }

  return false;
};

export default {
  props: {
    isCheckout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      create_account_message: "",
      doneRegistration: false,
      registration_type: null,
      loading: false,
      form: {
        opt_in: "",
        firstname: "",
        lastname: "",
        email: "",
        telephone: "",
        company: "",
        password1: "",
        password2: "",
        businesstype: "",
        enquiryreason: "",
        comments: "",
      },
      form_blank: {
        opt_in: "",
        firstname: "",
        lastname: "",
        email: "",
        telephone: "",
        company: "",
        password1: "",
        password2: "",
        businesstype: "",
        enquiryreason: "",
        comments: "",
      },
    };
  },
  validations() {
    var rules = {
      form: {
        opt_in: {},
        firstname: {
          required,
        },
        lastname: {
          required,
        },
        password1: {},
        password2: {},
        businesstype: {},
        enquiryreason: {},
        email: {
          required,
          email,
        },
        telephone: {
          required,
        },
        company: {
          required,
        },
      },
    };

    if (this.registration_type === "register") {
      rules.form.password1 = {
        required,
        passwordStrength,
      };

      rules.form.password2 = {
        required,
        passwordStrength,
      };
    } else {
      rules.form.businesstype = {
        required,
      };
      rules.form.enquiryreason = {
        required,
      };
    }

    return rules;
  },
  computed: {
    passwordStrength() {
      return wp.passwordStrength.meter(
        this.form.password1,
        wp.passwordStrength.userInputDisallowedList(),
        this.form.password2
      );
    },
    passwordStrengthErrorMessage() {
      if (!this.form.password1) {
        return "Please enter a password";
      }

      if (
        this.passwordStrength >= 3 &&
        this.passwordStrength < 5 &&
        !this.form.password2
      ) {
        return "Please confirm your password";
      }

      switch (this.passwordStrength) {
        case 2:
          return "Weak Password";
        case 3:
          return "";
        case 4:
          return "";
        case 5:
          return "Your passwords don't match";
        default:
          return "Too weak!";
      }
    },
    passwordStrengthMessage() {
      switch (this.passwordStrength) {
        case 2:
          return "Please enter a password of 9 or more characters including upper and lower case letters, numbers and symbols.";
        case 3:
          return "Good Password!";
        case 4:
          return "Strong Password!";
        case 5:
          return "Please enter a password of 9 or more characters including upper and lower case letters, numbers and symbols.";
        default:
          return "Please enter a password of 9 or more characters including upper and lower case letters, numbers and symbols.";
      }
    },
  },
  methods: {
    validateState(name, parent) {
      const { $dirty, $error } = parent
        ? this.$v.form[parent][name]
        : this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async doRegistration() {
      this.loading = true;
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("register");

      this.$store
        .dispatch("user/register", {
          ...this.form,
          recaptcha: token,
          type: this.registration_type,
        })
        .then((response) => {
          gtag("event", "sign_up", {
            method: "Website",
          });

          if (response.data.status === "exists") {
            this.showError(
              "An account already exists",
              "An account with this email address already exists. Please log in."
            );
          } else {
            this.$bvModal.msgBoxOk(
              "Thank you. We will contact you shortly to activate your account."
            );
            this.form = { ...this.form_blank };
            this.$v.$reset();
          }

          this.loading = false;
        })
        .catch((err) => {
          this.showError(
            "Error creating your account",
            "Sorry, there was a problem creating your account. Please try again later",
            err
          );
          this.loading = false;
        });
    },
  },
  mounted() {},
  components: {},
};
</script>